export default __webpack_public_path__ + "static/media/star-filled-hover.8b9e715e.svg";